var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIconHovered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 12.1217 2.84286 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84286 12.1217 2 10 2C7.87827 2 5.84344 2.84286 4.34315 4.34315C2.84286 5.84344 2 7.87827 2 10V10Z",
    fill: "#A8B2C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44097 5.62418C9.61313 5.50915 9.81554 5.44775 10.0226 5.44775C10.3002 5.44775 10.5665 5.55805 10.7628 5.75438C10.9592 5.95071 11.0695 6.21699 11.0695 6.49463C11.0695 6.70168 11.0081 6.90409 10.893 7.07625C10.778 7.24841 10.6145 7.38259 10.4232 7.46182C10.2319 7.54106 10.0214 7.56179 9.81835 7.5214C9.61529 7.481 9.42875 7.3813 9.28233 7.23489C9.13592 7.08848 9.03622 6.90194 8.99582 6.69887C8.95543 6.4958 8.97616 6.2853 9.0554 6.09401C9.13463 5.90272 9.26881 5.73922 9.44097 5.62418ZM10.75 10.0001C10.75 9.58586 10.4142 9.25007 9.99998 9.25007C9.58577 9.25007 9.24998 9.58586 9.24998 10.0001V14.0001C9.24998 14.4143 9.58577 14.7501 9.99998 14.7501C10.4142 14.7501 10.75 14.4143 10.75 14.0001V10.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconHovered);
export default __webpack_public_path__ + "static/media/infoIconHovered.a65067c2011712cd53a12f8ba308b511.svg";
export { ForwardRef as ReactComponent };